// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"15855766","453":"06d42fbc","866":"2e530529"}[chunkId] + ".chunk.js";
};